import React from 'react';
import { useTranslation } from 'react-i18next';
import { Platform, useWindowDimensions } from 'react-native';

import { Box, Text } from '../Restyle';
import Icon from '../shared/Icon/Icon';

export interface EmptyContactListPlaceHolder {
  showSmall?: boolean;
}
const EmptyContactListPlaceHolder: React.FC<EmptyContactListPlaceHolder> = ({
  showSmall = false,
}) => {
  const { height, width } = useWindowDimensions();
  const { t } = useTranslation('models');
  const EMPTY_ICON_WIDTH = width > 375 ? width / 2 : width / 1.8;
  const EMPTY_ICON_HEIGHT = height > 750 ? height / 6.2 : height / 5;
  return Platform.OS === 'web' ? (
    <>
      <Box
        flex={1}
        padding={showSmall ? 'none' : 'm'}
        justifyContent='center'
        marginHorizontal={showSmall ? 'none' : 'listFooter'}>
        <Box
          flex={1}
          justifyContent='center'
          alignItems='center'
          flexDirection='column'
          marginVertical='m'>
          <Icon name='WinnersTwoColor' width={200} height={151} />
          <Text
            variant={showSmall ? 'heading2' : 'heading1'}
            textAlign='center'
            paddingBottom='xs'
            color='onSurfaceSecondary'>
            {t('chat.emptyState.contactGroup')}
          </Text>
          <Text variant='body' textAlign='center' color='onSurfaceSecondary'>
            {t('chat.emptyState.contactGroupMessage')}
          </Text>
        </Box>
      </Box>
    </>
  ) : (
    <Box
      flex={1}
      padding='xs'
      justifyContent='center'
      alignItems='center'
      paddingBottom='listFooter'
      flexDirection='column'>
      <Box alignItems='center'>
        <Icon
          name='WinnersTwoColor'
          width={EMPTY_ICON_WIDTH}
          height={EMPTY_ICON_HEIGHT}></Icon>
      </Box>

      <Box flexDirection='column'>
        <Text
          variant='heading1'
          textAlign='center'
          paddingBottom='xs'
          color='onSurfaceSecondary'>
          {t('chat.emptyState.contactGroup')}
        </Text>
        <Text
          variant='body'
          textAlign='center'
          color='onSurfaceSecondary'
          paddingBottom="listFooter"
          marginHorizontal='m'>
          {t('chat.emptyState.contactGroupMessage')}
        </Text>
      </Box>
    </Box>
  );
};

export default EmptyContactListPlaceHolder;
